cb.define(['common/common_VM.Extend.js'], function (common) {
  var RM_rm_gatheringvouchlist_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
		viewmodel.on('afterInit', function () {
			debugger;
			//viewmodel.set("billnum","rm_retailvouchlist");
			//var teant = cb.rest.AppContext.user.tenant;
			var storeid = cb.rest.AppContext.user.storeId;
			//收款方式过滤条件
			var conditionPay = 
			{
				"isExtend": true,
				simpleVOs: []
			};
			
			conditionPay.simpleVOs.push({
				field: 'paymentMethodStore.store',
				op: 'eq',
				value1: storeid
			});
			
			//conditionPay.simpleVOs.push({
			//	field: 'tenant',
			//	op: 'eq',
			//	value1: teant
			//});
			viewmodel.get('gatheringVouchDetail.iPaymentid').getFromModel().setFilter(conditionPay);
			
			//制单人过滤条件
			var conditionPay = 
			{
				"isExtend": true,
				simpleVOs: []
			};		
			conditionPay.simpleVOs.push({
				field: 'stores.store',
				op: 'eq',
				value1: storeid
			});
			//conditionPay.simpleVOs.push({
			//	field: 'tenant',
			//	op: 'eq',
			//	value1: teant
			//});
			viewmodel.get('iMaker.name').getFromModel().setFilter(conditionPay);
		});
	  
    }
  }
  try {
    module.exports = RM_rm_gatheringvouchlist_filterVM_Extend;
  } catch (error) {

  }
  return RM_rm_gatheringvouchlist_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_gatheringvouchlist_filterVM.Extend.js